import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridReact } from "ag-grid-react";
import { DownloadAUMImportTemplate, exposureTemplateAPI, getPrivateExposureAssetList, getPrivateRawCategory, getPrivateRawData, getUserPageAccess, insertUpdatePrivateRawData } from "../../../../config/apiConfig";
import { sbaAxios } from "../../../utils/sbaAxios";
import moment from "moment/moment";
import { SBAComboBox } from "../../../UiComponents/SBADropDown";
import { UrlPath } from "../../../../config/routeConfig";
import { useNavigate } from "react-router";
import { Link, useParams } from "react-router-dom";
import { SBNotify } from "../../../utils/sbNotify";
import { useMemo } from "react";
import { useCallback } from "react";
import { getAsset } from "../../../actions/assetAction";
import { exportMultipleSheetsAsExcel } from "ag-grid-enterprise";
import { Modal } from "react-bootstrap";
import { getPercentageFormat, getPercentageValueFormat } from "../../../utils/conversionMethods";
import { excelStyles } from "../../../utils/excelExporter";
import { LoadingScreen } from "../../../UiComponents/LoadingComponent";
import { Unauthorized } from "../../../shared/ErrorPage/ErrorPage";
import { SBADrawer } from "../../../UiComponents/SBADrawer";
import * as XLSX from 'xlsx';


export const Data = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const history = useNavigate();
  const gridAssetRef = useRef();
  const gridGeographicalRef = useRef();
  const gridTotalRef = useRef();
  const [render, setRender] = useState(true);
  const Gstate =
    useSelector((state) => {
      return state;
    }) || {};
  const AssetListDDL = Gstate.assetDDL.assetList || [];
  const currentAsset = Gstate.asset.asset || {};
  const [AssetListData, setAssetListData] = useState([]);
  const [selectedasset, setselectedasset] = useState([]);
  const [Category, setCategory] = useState([]);
  const [selectedCategory, setselectedeCategory] = useState({});


  const [griddata1, setGriddata1] = useState([])
  const [griddata2, setGriddata2] = useState([])
  const [griddata3, setGriddata3] = useState([])


  const [saveData, setSaveData] = useState([]);
  const [hiddenCategory,setHiddenCategory]=useState(null);
  // const [types, setTypes] = useState(1);


  const [formattedAssetData,setFormattedAssetData]=useState([]);
  const [formattedGeographicalData,setFormattedGeographicalData]=useState([]);
  const [formattedTotalData,setFormattedTotalData]=useState([]);
  const [showModal,setShowModal]=useState(false);

  const [openDrawer,setOpenDrawer]=useState(false);


  const [accessConfiguration,setAccessConfiguration]=useState({isLoading:true,isAccessible:false});
  useEffect(() => {
    assetListData();
    getAvailableCategory();
    document.title="Exposure";
    sbaAxios({ url: `${getUserPageAccess}?keyName=ExposureDataTabAccess` }).then(res=>{setAccessConfiguration({isAccessible:res,isLoading:false})}).catch(()=>{setAccessConfiguration({isAccessible:false,isLoading:false})});
  }, []);
  useEffect(()=>{
    dispatch(getAsset(params.Asset));
  },[params.Asset]);
  // useEffect(() => {
  //   if (currentAsset) {
  //     setselectedasset(currentAsset);
  //   }
  // }, [Gstate]);


  // useEffect(() => {
  //   // getGridData();
  // }, [selectedasset, selectedCategory]);


  const assetListData = async () => {
    try {
      const response = await sbaAxios({
        url: `${getPrivateExposureAssetList}`,
        method: "get",
      });
      const data = response;
      setAssetListData(data);
    } catch (error) {
      console.error("Error fetching assetListData from API:", error);
    }
  };

  const getAvailableCategory = async () => {
    try {
      const response = await sbaAxios({
        url: `${getPrivateRawCategory}`,
        method: "get",
      });
      const data = response;
      setCategory(data);
      getGridData(params.Asset,data,data[0]);
      // setTypes(1);
    } catch (error) {
      console.error("Error fetching AvailableChartLists from API:", error);
    }
  };


  const getGridData = async (AssetId,catergories,category) => {
    if (true) {
      try {
        catergories.map(async(category)=>{
          const data = await sbaAxios({
            url: `${getPrivateRawData}/${AssetId}/${category.ExposureParentId}`,
            method: "get",
          });
          if (category.ExposureParentId === 133) {
            setFormattedAssetData(val => getFormattedData(data));
            setGriddata1(data);

          }
          if (category.ExposureParentId === 128) {
            setFormattedGeographicalData(val=>getFormattedData(data));
            setGriddata2(data);

          }
          if (category.ExposureParentId === 134) {
            setFormattedTotalData(val=>getFormattedData(data));
            setGriddata3(data);
          }
        })
        setselectedeCategory(category);
        setSaveData([]);
      } catch (error) {
        console.error("Error fetching AvailableChartLists from API:", error);
        setGriddata1([]);
        setGriddata2([]);
        setGriddata3([]);
        setFormattedAssetData([]);
        setFormattedGeographicalData([]);
        setFormattedTotalData([]);
        setSaveData([]);
      }
    }
  };
  const AssestDDChanged = (e) => {
    if(e.value)
    {
      history(`${UrlPath.PrivateExposure}${e.value.AssetId}`);
      // setselectedasset(e.value);
      getGridData(e.value.AssetId,Category,selectedCategory);
    }
    setRender(!render);

  };

  const saveRequest = (saveData) => {
    try {
     if(saveData.length>0)
     {
      sbaAxios({
        url: insertUpdatePrivateRawData,
        method: "post",
        data: saveData,
      }).then((response) => {
        SBNotify({ Msg: "Exposure data saved successfully" });
        setSaveData([]);
        getGridData(params.Asset,Category,selectedCategory);

      })
        .catch((e) => {
          SBNotify({ Msg: "error saving data", type: "error" });
        });
     };
    } catch (error) {
      console.error("Error in saveRequest:", error);

      return [];
    }
  };

  const saveButtonClick = async (event) => {
    await gridAssetRef.current.api.stopEditing();
    await gridGeographicalRef.current.api.stopEditing();
    await gridTotalRef.current.api.stopEditing();
    setTimeout(() => {
      saveRequest(saveData);
    }, 500);
  };
  const downloadExcel = () => {
    var spreadsheets = [];
  
    spreadsheets.push(
      gridAssetRef.current.api.getSheetDataForExcel({ sheetName: "Asset Level" }),
  
      gridGeographicalRef.current.api.getSheetDataForExcel({ sheetName: "Geographical Level" }),
  
      gridTotalRef.current.api.getSheetDataForExcel({ sheetName: "Total Levl" })
    );
  
    exportMultipleSheetsAsExcel({
      data: spreadsheets,
      fileName: currentAsset.AssetName + " Exposure Data.xlsx",
    });
  };
  

  const rowDataUpdated = (params) => {
    params.api.forEachNode((node, index) => {
      if (index === 0) {
        node.setSelected(true);
      }
    });
  };
  const onCellValueChanged = async (e) => {
    try {

      const dateToUpdate = e.column.colId;

      const updateSaveData = (gridData) => {
        const filteredData = gridData.filter(item => item.ExposureDate === dateToUpdate && item.ExposureTypeId === e.data.ExposureTypeId && item.ExposureId === e.data.ExposureId);
        const updatedData = filteredData.map(item => ({ ...item, AssetId: parseInt(params.Asset), ExposureValue: e.newValue / 100 }));
        const updatedRecordIndex = saveData.findIndex(item => item.ExposureDate === dateToUpdate && item.ExposureTypeId === e.data.ExposureTypeId && item.ExposureId === e.data.ExposureId);
      
        setSaveData(prev => {
          const updatedSaveData = [...prev];
          updatedRecordIndex === -1 ? updatedSaveData.push(updatedData[0]) : updatedSaveData[updatedRecordIndex] = updatedData[0];
          return updatedSaveData;
        });
      };
      
      if (selectedCategory.ExposureParentId === 133) updateSaveData(griddata1);
      if (selectedCategory.ExposureParentId === 128) updateSaveData(griddata2);
      if (selectedCategory.ExposureParentId === 134) updateSaveData(griddata3);
     

    } catch (error) {
      console.error("Error while saving data:", error);
    }
  };
  const CategoryDDChanged = (e) => {
    if (e.value) {
      if(saveData.length>0)
      {
        setHiddenCategory(e.value);
        setShowModal(true);
        return;
      }
      setselectedeCategory(e.value);
      
    }
  };
  const autoGroupColumnDef = useMemo(() => {
    return {
        headerName: 'CountryName',
        field:"ExposureName",
        minWidth: 300,
        cellRendererParams: {
            suppressCount: true,
        },
        pinned: "left",
        editable: false,
        headerClass:"ag-grid-BR",
        valueFormatter:(e)=>{  if(Array.isArray(e.value)){return e.value[1]}else return e.value}
    }
}, []);

const handleFileChange = (event) => {
  const file = event.target.files[0];
  const { name } = event.target;

  if (!file) return;
    if (!file.name.endsWith(".xls") && !file.name.endsWith(".xlsx")) {
      return;
    }
  const updatedState = { [name]: file };
  if (file) {
    const reader = new FileReader();
    reader.onload = (event) => {
      const fileContent = event.target.result;

        const workbook = XLSX.read(fileContent, { type: 'binary' ,cellDates: true});
      const exceldata=[];
      if(selectedCategory.ExposureParentId === 133)
      {
        const asssetLevel = workbookToSheetsArray(workbook)[0];
        if(asssetLevel)
        {
          const dataTable=asssetLevel.table;
          const columnsNames=dataTable[4];
          const exposureTypes=dataTable[3];
          const exposureNames=dataTable[4];
          const rowValues=dataTable.slice(5);
          const assetId=dataTable[0][1]
          const exposureID=dataTable[1][1]
          const dataModel = {
            "AssetExposureId": 0,
            "AssetId": assetId,
            "ParentId": 133,
            "ParentName": "Asset Level",
            "ExposureId": exposureID,
            "ExposureName": "Fund Level Exposure",
            "ExposureTypeId": 0,
            "ExposureType": '',
            "ExposureDate": 0,
            "ExposureValue": 0
          }
          const exposureType={};
          const exposureName={};
          exposureTypes.map((item,itemIndex)=>{ 
            if(itemIndex!=0)
              exposureType[item]=itemIndex;
          });
          exposureNames.map((item,itemIndex)=>{ 
            exposureName[item]=itemIndex;
          });
          rowValues.map((item, index) => {
            if(item[dataModel.ExposureDate])
            {
              Object.entries(exposureType).map(([key, value]) => {
                exceldata.push({
                    "AssetExposureId": 0,
                    "AssetId": parseInt(params.Asset),
                    "ParentId": 133,
                    "ParentName": "AssetLevel",
                    "ExposureId": exposureID,
                    "ExposureName": "Fund Level",
                    "ExposureTypeId": parseInt(key) ,
                    "ExposureType": '',
                    "ExposureDate": moment(item[dataModel.ExposureDate]).format("YYYY-MM-DD") + "T00:00:00",
                    "ExposureValue": item[value]?item[value]:0,
                });
              });
            }
         
          });
          const formattedGridData=exceldata.map((dataItem)=>{
            const singleData=griddata1.find(item=>item.ExposureDate==dataItem.ExposureDate && item.ExposureTypeId==dataItem.ExposureTypeId)
            dataItem.AssetExposureId=singleData?.AssetExposureId || 0;
            return dataItem
          })
          
          setSaveData(formattedGridData);
        }
      }
      if(selectedCategory.ExposureParentId === 128)
      {
        const geoLevel = workbookToSheetsArray(workbook);
        if(geoLevel)
        {
          geoLevel.map((column, colIndex) => {
            const dataTable=column.table;
            const columnsNames=dataTable[4];
            const exposureTypes=dataTable[3];
            const exposureNames=dataTable[4];
            const rowValues=dataTable.slice(5);
            const assetId=dataTable[0][1]
            const exposureID=dataTable[1][1]
            const dataModel = {
              "AssetExposureId": 0,
              "AssetId": assetId,
              "ParentId": 128,
              "ParentName": "Geographical Level",
              "ExposureId": exposureID,
              "ExposureName": "",
              "ExposureTypeId": 0,
              "ExposureType": 0,
              "ExposureDate": 0,
              "ExposureValue": 0
            }
            const exposureType={};
            const exposureName={};
            exposureTypes.map((item,itemIndex)=>{ 
              if(itemIndex!=0)
                exposureType[item]=itemIndex;
            });
            exposureNames.map((item,itemIndex)=>{ 
              exposureName[item]=itemIndex;
            });
            rowValues.map((item, index) => {
              if(item[dataModel.ExposureDate])
              {
                Object.entries(exposureType).map(([key, value]) => {
                  exceldata.push({
                      "AssetExposureId": 0,
                      "AssetId": parseInt(params.Asset),
                      "ParentId": 128,
                      "ParentName": "Geographical Level",
                      "ExposureId": exposureID,
                      "ExposureName": "",
                      "ExposureTypeId": parseInt(key) ,
                      "ExposureType": '',
                      "ExposureDate": moment(item[dataModel.ExposureDate]).format("YYYY-MM-DD") + "T00:00:00",
                      "ExposureValue": item[value]?item[value]:0,
                  });
                });
              }
           
            });
        })
          const formattedGridData=exceldata.map((dataItem)=>{
            const singleData=griddata2.find(item=>item.ExposureDate==dataItem.ExposureDate && item.ExposureTypeId==dataItem.ExposureTypeId && item.ExposureId===dataItem.ExposureId)
            dataItem.AssetExposureId=singleData?.AssetExposureId || 0;
            return dataItem
          }) 
          setSaveData(formattedGridData);
        }
      }
      if(selectedCategory.ExposureParentId === 134)
      {
        const totalLevel = workbookToSheetsArray(workbook)[0];
        if(totalLevel)
        {
          const dataTable=totalLevel.table;
          const columnsNames=dataTable[4];
          const exposureTypes=dataTable[3];
          const exposureNames=dataTable[4];
          const rowValues=dataTable.slice(5);
          const assetId=dataTable[0][1]
          const exposureID=dataTable[1][1]
          const dataModel = {
            "AssetExposureId": 0,
            "AssetId": assetId,
            "ParentId": 134,
            "ParentName": "Total Level",
            "ExposureId": exposureID,
            "ExposureName": "Total Level Exposure",
            "ExposureTypeId": 0,
            "ExposureType": 0,
            "ExposureDate": 0,
            "ExposureValue": 0
          }
          const exposureType={};
          const exposureName={};
          exposureTypes.map((item,itemIndex)=>{ 
            if(itemIndex!=0)
              exposureType[item]=itemIndex;
          });
          exposureNames.map((item,itemIndex)=>{ 
            exposureName[item]=itemIndex;
          });
          rowValues.map((item, index) => {
            if(item[dataModel.ExposureDate])
            {
              Object.entries(exposureType).map(([key, value]) => {
                exceldata.push({
                    "AssetExposureId": 0,
                    "AssetId": parseInt(params.Asset),
                    "ParentId": 134,
                    "ParentName": "Total Level",
                    "ExposureId": exposureID,
                    "ExposureName": "Total Level",
                    "ExposureTypeId": parseInt(key) ,
                    "ExposureType": '',
                    "ExposureDate": moment(item[dataModel.ExposureDate]).format("YYYY-MM-DD") + "T00:00:00",
                    "ExposureValue": item[value]?item[value]:0,
                });
              });
            }
         
          });
          const formattedGridData=exceldata.map((dataItem)=>{
            const singleData=griddata3.find(item=>item.ExposureDate==dataItem.ExposureDate && item.ExposureTypeId==dataItem.ExposureTypeId)
            dataItem.AssetExposureId=singleData?.AssetExposureId || 0;
            return dataItem
          })
          
          setSaveData(formattedGridData);
        }

      }
    };  
    reader.readAsBinaryString(file);
  }
};
const workbookToSheetsArray = (workbook) => {
if(selectedCategory.ExposureParentId === 128)
{
  const sheetNames = workbook.SheetNames.filter(
    (sheetName, index) => index!==0
  );
  const sheetsArray = [];
  sheetNames.forEach((sheetName) => {
    const sheet = workbook.Sheets[sheetName];
    const table = XLSX.utils.sheet_to_json(sheet, { header: 1 });
    sheetsArray.push({ name: sheetName, table: table });
  });
  return sheetsArray;
}
else
{
  const sheetsArray = [];
  workbook.SheetNames.forEach((sheetName) => {
    const sheet = workbook.Sheets[sheetName];
    const table = XLSX.utils.sheet_to_json(sheet, { header: 1 });
    sheetsArray.push({ name: sheetName, table: table });
  });
  return sheetsArray;
}
};
const uniqueDates = [
    ...new Map(
      griddata1.map((item) => [
        moment(item.ExposureDate).format("MMM-YYYY"),
        { FormatedDate: moment(item.ExposureDate).format("MMM-YY"), date: item.ExposureDate },
      ])
    ).values(),
  ].sort((a, b) => moment(b.FormatedDate, "MMM-YY").toDate() - moment(a.FormatedDate, "MMM-YY").toDate());
  
  const ColumnAssetDefs = [
    {
      headerName: "Type",
      field: "Type",
      cellStyle: { textAlign: "left" },
      pinned: "left",
      minWidth: 100,
      // hide: types == 3
    },
    ...uniqueDates.map((item) => ({
      headerName: item.FormatedDate,
      field: item.date,
      cellStyle: { textAlign: "right" },
      minWidth: 100,
      editable: true,
      cellRenderer: (params) => {
        return PercentageRenderer(params);
      },
      // valueParser: (params) => params.newValue / 100,
      cellClass:"percentageFormat"

    })),
  ];
  const ColumnGeoDefs = [
    {
      headerName: "Type",
      field: "Type",
      cellStyle: { textAlign: "left" },
      pinned: "left",
      minWidth: 100,
      hide: true,
    },
    ...uniqueDates.map((item) => ({
      headerName: item.FormatedDate,
      field: item.date,
      cellStyle: { textAlign: "right" },
      minWidth: 100,
      cellRenderer: (params) => {
        return PercentageRenderer(params);
      },
      // valueParser: (params) => params.newValue / 100,
      editable: true,
      cellClass:  "percentageFormat"
    })),
  ];
  
  const ColumnTotalDefs = [
    {
      headerName: "Type",
      field: "Type",
      cellStyle: { textAlign: "left" },
      pinned: "left",
      minWidth: 100,
      // hide: types == 3
    },
    ...uniqueDates.map((item) => ({
      headerName: item.FormatedDate,
      field: item.date,
      cellStyle: { textAlign: "right" },
      minWidth: 100,
      editable: true,
      cellRenderer: (params) => {
        return PercentageRenderer(params);
      },
      // valueParser: (params) => params.newValue / 100,
      cellClass:"percentageFormat"

    })),
  ];
  
  const getDataPath = useCallback(data => data.ExposureName, []);
  
  const defaultColDef = {
    flex: 1,
    sortable: true,
    filter: true,
    resizable: true,
  };
  const getContextMenuItems = (params) => {
    if (!params.node.group) {
      return [
        "copy",
        {
          name: "Copy Row",
          action: () => copyVisibleRow(params),
        },
      ];
    }
    return []; 
  };

  const copyVisibleRow = (params) => {
    const api = params.api;
    const columnDefs = api.getColumnDefs();
    
    const visibleColumns = columnDefs.filter((col) => !col.hide).map((col) => col.field);
    const formattedValues = visibleColumns.map((field) => api.getValue(field, params.node));
    const rowText = formattedValues.join("\t"); 
    navigator.clipboard.writeText(rowText).then(() => {
      SBNotify({Msg:"Row copied to clipboard!"});
    });
  };
  
const DownloadFile=()=>
{
  let url=exposureTemplateAPI;
  if(selectedCategory.ExposureParentId === 133)
  {
    url+="/ExposureDataImport.xlsx";
  }
  if(selectedCategory.ExposureParentId === 134)
  {
    url+="/ExposureDataImport -Total Level.xlsx"
    
  }
  if(selectedCategory.ExposureParentId === 128)
  {
    url+="/ExposureDataImport -Geography Level.xlsx"
  }
  sbaAxios({
    url,
    responseType: 'blob'
}).then((response) => {
    var downloadLink = document.createElement('a');
    downloadLink.href = URL.createObjectURL(response);
    if(selectedCategory.ExposureParentId === 133)
    downloadLink.download ="ExposureDataImport - Fund Level.xlsx";
    if(selectedCategory.ExposureParentId === 134)
      downloadLink.download = "ExposureDataImport - Total Level.xlsx";
      if(selectedCategory.ExposureParentId === 128)
      downloadLink.download = "ExposureDataImport - Geography Level.xlsx";
    downloadLink.click();   
});

}
  return (
    <> {accessConfiguration.isLoading ? <><LoadingScreen /></> : <>
      {accessConfiguration.isAccessible ? <>
        <div>
          <div className="row">
            <div className="col-md-3">
              <label className="mb-1 ms-2 fw-semibold fs-12">Asset</label>
              <div>
                <SBAComboBox
                  filterable={true}
                  data={AssetListData}
                  textField="AssetName"
                  valueField="AssetId"
                  value={currentAsset}
                  onChange={AssestDDChanged}
                />
              </div>
            </div>
            <div className="col-md-3">
              <label className="mb-1 ms-2 fw-semibold fs-12">Category</label>
              <div>
                <SBAComboBox
                  data={Category}
                  textField="ExposureParent"
                  valueField="ExposureParentId"
                  value={selectedCategory}
                  onChange={CategoryDDChanged}
                  filterable={true}
                  placeholder="--Please Select--"
                />
              </div>
            </div>
            <div className="col-md-6 d-flex row-items">
              <button
                className="p-sm-btn mx-1 ms-auto"
                onClick={() => { saveButtonClick() }}
              >
                Save

              </button>
              <button
                className="p-sm-btn mx-1 "
                onClick={() => { setOpenDrawer(true)}}
               // disabled={selectedCategory.ExposureParentId == 128 }
              >
                Import
              </button>
              <button
                className="p-sm-btn mx-1 "
                onClick={() => { downloadExcel() }}
              >
                <img src="/images/download.svg" alt="Download" />
                Export
              </button>
            </div>

          </div>
          <>
            <div
              className="ag-theme-alpine"
              style={{ width: "100%", height: "500px", marginTop: "20px", display: selectedCategory.ExposureParentId == 133 ? 'block' : 'none' }}
            >
              <AgGridReact
                columnDefs={ColumnAssetDefs}
                rowData={formattedAssetData}
                defaultColDef={defaultColDef}
                ref={gridAssetRef}
                autoGroupColumnDef={autoGroupColumnDef}
                onCellValueChanged={onCellValueChanged}
                excelStyles={excelStyles}
              // onRowDataUpdated={rowDataUpdated}
              getContextMenuItems={getContextMenuItems}
              />
            </div>
            <div
              className="ag-theme-alpine"
              style={{ width: "100%", height: "500px", marginTop: "20px", display: selectedCategory.ExposureParentId == 128 ? 'block' : 'none' }}
            >
              <AgGridReact
                columnDefs={ColumnGeoDefs}
                rowData={formattedGeographicalData}
                defaultColDef={defaultColDef}
                ref={gridGeographicalRef}
                autoGroupColumnDef={autoGroupColumnDef}
                treeData={true}
                getDataPath={getDataPath}
                onCellValueChanged={onCellValueChanged}
                excelStyles={excelStyles}
                getContextMenuItems={getContextMenuItems}

              //onRowDataUpdated={rowDataUpdated}
              />
            </div>
            <div
              className="ag-theme-alpine"
              style={{ width: "100%", height: "500px", marginTop: "20px", display: selectedCategory.ExposureParentId == 134 ? 'block' : 'none' }}
            >
              <AgGridReact
                columnDefs={ColumnTotalDefs}
                rowData={formattedTotalData}
                defaultColDef={defaultColDef}
                ref={gridTotalRef}
                excelStyles={excelStyles}
                getContextMenuItems={getContextMenuItems}
                onCellValueChanged={onCellValueChanged}
              // onRowDataUpdated={rowDataUpdated}
              />
            </div>
          </>
          {/* <ToastContainer /> */}
          <SBADrawer open={openDrawer} setOpen={setOpenDrawer} title={"Import Exposure"} >
            <div className="row">
              <label className="label d-block">Import Excel Sheet</label>
              <input type="file" accept=".xls,.xlsx" onChange={handleFileChange} className="mb-2" />
            </div>
            <Link onClick={DownloadFile}> Download Exposure Data Template file</Link>
            <div className="d-flex mt-2">

            <button className='s-sm-btn mx-1'
              onClick={() => { setOpenDrawer(false); setSaveData([]); }}
            >
              Cancel
            </button>
            <button className='p-sm-btn mx-1'
              onClick={() => { setOpenDrawer(false); saveRequest(saveData) }}
            >
              Upload
            </button>

            </div>
          </SBADrawer>
        </div>
        <Modal show={showModal}  >
          <Modal.Header closeButton onClick={() => { setShowModal(false) }}>
            <Modal.Title> Are you sure?</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
              Your work isn’t saved yet. Leaving now will delete any changes made.
            </p>
          </Modal.Body>
          <Modal.Footer>
            <button className="s-sm-btn mx-1"
              onClick={() => {
                // saveRequest(); 
                setShowModal(false);
              }}

            >Cancel</button>
            <button className='p-sm-btn mx-1'
              onClick={() => { setShowModal(false); setSaveData([]); getGridData(params.Asset, Category, hiddenCategory); }}


            >
              Yes
            </button>
          </Modal.Footer>
        </Modal>
      </> : <><Unauthorized /></>}
    </>}


    </>
  );
};
function getFormattedData(griddata){
  const groupedData = griddata.reduce((acc, item) => {
    (acc[item.ExposureName] = acc[item.ExposureName] || []).push(item);
    return acc;
  }, {});
  const formattedData=[];
  Object.entries(groupedData).map(([nameGroup, nameValue]) => {
    const typeGroups = nameValue.reduce((acc, item) => {
      (acc[item.ExposureType] = acc[item.ExposureType] || []).push(item);
      return acc;
    }, {});   
    Object.entries(typeGroups).map(([Types, Typesvalue]) => {
      const record={};
      Typesvalue.map(item => {
        record.Type = Types;
        record.ExposureTypeId = item.ExposureTypeId;
        record.ParentId=item.ParentId;
        record.ExposureId=item.ExposureId;
        record.ExposureName = [nameGroup,Types];  
        record[item.ExposureDate] = item.ExposureValue*100;
      });
      formattedData.push(record);
    });
  });
  const sorttedData=formattedData.sort((a,b)=>a.ExposureTypeId-b.ExposureTypeId);
  return sorttedData;
}
const PercentageRenderer = ({ value }) => {
  if (value === null || (value)==undefined || (value==NaN)) {
      return <span></span>;
  }
  return <span>{(parseFloat(value)).toFixed(2) }%</span>;
};